<template>
  <template v-if="view==='listar'">

    <button class="flex items-center px-2 py-1 text-white bg-orange-500 rounded-md hover:bg-orange-600 focus:outline-none"
        style="white-space: nowrap;"  @click="$emit('updateValues', {'view': 'comprobantes_siiaf_embargo'});$emit('data', data);"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-5 mr-1">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>

      SIIAF
    </button>

  </template>
</template>
<script>

export default {
  name: 'BotonComprobanteSiiafEmbargoPersonaComponent',
  props: ['view', 'data'],
  emits: ['updateValues', 'data']
}
</script>
